const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const num = (n) => Number(n || 0).toLocaleString("id-ID");
const fmtCreated = (iso) => {
  const d = iso ? new Date(iso) : new Date();
  return `${String(d.getDate()).padStart(2, "0")}-${BULAN[d.getMonth()]}-${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const voucherPdfName = ({ routerName, profile, createdAt, count }) => {
  const branch = String(routerName || "FASNET").replace(/\s+/g, "").toUpperCase();
  const prof = String(profile || "VOUCHER").replace(/\s+/g, "").toUpperCase();
  const d = createdAt ? new Date(createdAt) : new Date();
  const tgl = `${String(d.getDate()).padStart(2, "0")}${BULAN[d.getMonth()]}${d.getFullYear()}`;
  const rand = Math.floor(1000000000 + Math.random() * 9000000000);
  return `vcr-${branch}-${prof}-${tgl}-${count}pcs-${rand}.pdf`;
};

export const downloadVoucherPdf = async (opts) => {
  const { doc, filename } = await buildVoucherPdf(opts);
  doc.save(filename);
};

export const voucherPdfFile = async (opts) => {
  const { doc, filename } = await buildVoucherPdf(opts);
  return new File([doc.output("blob")], filename, { type: "application/pdf" });
};

export const buildVoucherPdf = async ({ vouchers, routerName, profile, createdAt, showPrice = true }) => {
  const { jsPDF } = await import("jspdf");
  const list = vouchers || [];
  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "landscape" });
  const cols = 10, rowsPerPage = 10, margin = 1.5, gap = 1;
  const cw = (297 - margin * 2 - gap * (cols - 1)) / cols;
  const ch = (210 - margin * 2 - gap * (rowsPerPage - 1)) / rowsPerPage;
  const perPage = cols * rowsPerPage;
  list.forEach((v, i) => {
    if (i > 0 && i % perPage === 0) doc.addPage();
    const idx = i % perPage;
    const x = margin + (idx % cols) * (cw + gap);
    const y = margin + Math.floor(idx / cols) * (ch + gap);
    doc.setDrawColor(90);
    doc.setLineWidth(0.25);
    doc.rect(x, y, cw, ch);
    doc.setFontSize(6);
    doc.setFont("helvetica", "bold");
    doc.text((routerName || "FASNET WIFI").toUpperCase(), x + 1.5, y + 3.8);
    if (showPrice && (v.jual ?? v.price)) doc.text(`Rp${num(v.jual ?? v.price)}`, x + cw - 1.5, y + 3.8, { align: "right" });
    const code = String(v.name);
    doc.setFontSize(code.length > 10 ? 9 : code.length > 8 ? 11 : 13);
    doc.text(code, x + cw / 2, y + 9.8, { align: "center" });
    doc.setFontSize(5.5);
    doc.setFont("helvetica", "normal");
    doc.text(String(profile || v.profile || "").toUpperCase(), x + 1.5, y + 14.2);
    doc.text("login: fas.net", x + cw - 1.5, y + 14.2, { align: "right" });
    doc.setFontSize(4.5);
    doc.text(`Cetak: ${fmtCreated(createdAt)} [${i + 1}]`, x + cw / 2, y + 17.8, { align: "center" });
  });
  return { doc, filename: voucherPdfName({ routerName, profile, createdAt, count: list.length }) };
};

export const voucherCopyText = ({ vouchers, profile }) =>
  (vouchers || []).map((v, i) => `${i + 1}. ${v.name}   ${String(profile || v.profile || "").toUpperCase()}`).join("\n");
